import { isEmptyString } from '../utils'
import { BeneficiaryDTO } from './beneficiary'
import { TimeType } from './generic'

export type TaskDTO = {
  archivedAt?: TimeType
  beneficiaryId: string
  categories?: string[]
  content: string
  createdAt: TimeType
  cta?: TaskCtaDTO
  dueDate?: TimeType
  durationInHours?: number
  id: string
  title: string
  updatedAt: TimeType
}

export type TaskWithBeneficiaryDTO = {
  archivedAt?: TimeType
  beneficiaryFullName: BeneficiaryDTO['fullName']
  beneficiaryId: BeneficiaryDTO['id']
  categories?: string[]
  content: string
  createdAt: TimeType
  cta?: TaskCtaDTO
  dueDate?: TimeType
  durationInHours?: number
  id: string
  title: string
  updatedAt: TimeType
}

// Type used in TaskEntity
export type TaskCtaType = {
  link: string
  name: string
}

export type TaskCtaDTO = TaskCtaType

export const isEmptyCategories = (categories?: string[]): boolean =>
  !categories || categories.filter((v) => !isEmptyString(v)).length === 0
